// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ScheduleOutlinedSvg from "@fishx/icons-svg/es/asn/ScheduleOutlined";
import FishxIcon from '../components/FishxIcon';

var ScheduleOutlined = function ScheduleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ScheduleOutlinedSvg
  }));
};

ScheduleOutlined.displayName = 'ScheduleOutlined';
export default React.forwardRef(ScheduleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ScheduleOutlined.js
// module id = 4063
// module chunks = 0